import { getLocaleDateTimeFormat } from '@angular/common';
import { Input, ViewChild } from '@angular/core';
import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UIChart } from 'primeng/chart';
import { Subscription } from 'rxjs';
import { CustomComponent } from 'src/app/core/view/component/custom/custom-component.interface';
import { OrganizationsService } from '../../organizations.service';

@Component({
  selector: 'app-opportunities-widget',
  templateUrl: './opportunities-widget.component.html',
  styleUrls: ['./opportunities-widget.component.scss']
})
export class OpportunitiesWidgetComponent implements OnInit, CustomComponent {
  @ViewChild('chart') chart: UIChart;
  @Input() public data: any;

  public id;
  public ret: any = {};

  constructor(
    private organizationService: OrganizationsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
   this.route.params.subscribe(params => {
      this.id = params['id'];
      this.loadStatsOpportunities(this.id);
    });
  }

  onEvent(event: string) {
    this.refresh();
  }

  refresh(){
    this.loadStatsOpportunities(this.id);
    this.chart.reinit();
    this.chart.refresh();
  }

  loadStatsOpportunities(id) {
    this.organizationService.statsOpportunities(id).subscribe(
      data => {
        this.ret = data;
        this.loadBasicDataYears();
      },
      error => {
        //TODO: messageService aquí.
      }
    );
  }

  //Configuración de tablas horizontales para años.
  public basicDataYears: any;
  public horizontalOptionsYears: any;
  loadBasicDataYears() {
    var anyoActual = new Date().getFullYear();

    this.basicDataYears = {
      labels: [anyoActual+"      ", anyoActual - 1+"      ", anyoActual - 2+"      ", anyoActual - 3+"      ", anyoActual - 4+"      "],
      datasets: [
        {
          label: 'Total de venta por año',
          backgroundColor: '#90cdc4',
          data: this.ret.sumYears
        }
      ]
    };

    this.horizontalOptionsYears = {
      indexAxis: 'y',
      tooltips:{
        callbacks:{
          label: function(tooltipItem,data){
            var label = new Intl.NumberFormat('es-ES').format(tooltipItem.value);
            return label+" €";
          }
        }
      },
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
  };
}
